//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { openDB } from "idb";
import axios from "axios";
import moment from "moment";
import { mapActions, mapMutations } from "vuex";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import CustomDatePicker from "./CustomDatePicker";
import CustomTimePicker from "./CustomTimePicker";
export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    CustomDatePicker,
    CustomTimePicker,
  },
  data: () => ({
    showSnackbar: false,
    snackbarMessage: "",
    snackbarColor: "error",
    showBusyAni: false,
    showRefreshBusyAni: false,
    randInfoConfirmed: false,

    tno: null,
    randDate: null,
    randTime: null,
    trialAllocation: null,
    deviceOffline: null,
    offlineTempTNO: "",
    siteOrgCode: "",
    sites: [],
    strataTimeOfDay: null,
    appUserId: "",
    randDateTime: null,
    tbCodeTimeOfDay: [
      {
        value: 1,
        text: "Day (08:00-17:59)",
      },
      {
        value: 2,
        text: "Night (18:00-07:59)",
      },
    ],
  }),
  computed: {
    minRandDate() {
      return moment().startOf("month").add(-7, "days").format("YYYY-MM-DD");
    },
    maxRandDate() {
      return moment().format("YYYY-MM-DD");
    },
  },
  methods: {
    ...mapMutations(["setCrfTitle"]),
    ...mapActions([
      "fetchAppUserId",
      "fetchSites",
      "fetchDefaultSiteOrgCode",
      "clientIsOffline",
      "saveOfflineRandomisation",
    ]),
    getDayOrNight() {
      const dayLowerLimit = moment("08:00", "HH:mm");
      const dayUpperLimit = moment("17:59", "HH:mm");
      const isDay = moment().isBetween(dayLowerLimit, dayUpperLimit);
      return isDay ? 1 : 2;
    },
    async randomiseParticipant() {
      //debugger;
      const isFormValid = await this.$refs.frmRand.validate();
      if (!isFormValid) {
        this.snackbarColor = "error";
        this.snackbarMessage = "Form contains validation warning(s).";
        this.showSnackbar = true;
        return;
      }
      this.randDateTime = moment(
        `${this.randDate} ${this.randTime}${moment().format("ss")}`,
        "YYYY-MM-DD HH:mm:ss"
      );
      this.deviceOffline = 1;
      const fdata = {
        randDate: this.randDateTime.format("YYYY-MM-DDTHH:mm:ss"),
        trialAllocation: this.trialAllocation,
        deviceOffline: this.deviceOffline,
        siteOrgCode: this.siteOrgCode,
        strataTimeOfDay: this.strataTimeOfDay,
        appUserId: this.appUserId,
      };
      //console.log(fdata.randDate);
      this.showBusyAni = true;
      let clientIsOffline = await this.clientIsOffline();
      //this.showBusyAni = true;
      if (clientIsOffline) {
        //save to local db
        //console.log(clientIsOffline);
        await this.randomiseParticipantOffline();
        this.$router.push({ name: "rand-outcome", params: { notify: true } });
      } else {
        //save to live db
        const actionUrl = `${process.env.BASE_URL}Randomisation/RandomiseParticipant`;
        try {
          const {
            data: {
              rstatus,
              rdata: { tno, trialAllocation, activeSites } = {},
            },
          } = await axios.post(actionUrl, fdata);

          if (rstatus == 0) {
            const sdata = {
              tno,
              trialAllocation,
              randDate: this.randDateTime.format("DD/MM/YYYY HH:mm:ss"),
              deviceOffline: this.deviceOffline,
            };
            const db = await openDB("AIRWAYS3idb");
            await db
              .transaction("tbSettings", "readwrite")
              .objectStore("tbSettings")
              .put(sdata, "latestRandResult");

            await db
              .transaction("tbSettings", "readwrite")
              .objectStore("tbSettings")
              .put(activeSites, "sites");

            await db
              .transaction("tbPostRandCRF", "readwrite")
              .objectStore("tbPostRandCRF")
              .add(null, tno);

            this.$router.push({
              name: "rand-outcome",
              params: { notify: true },
            });
          } else if (rstatus == -2) {
            //mobile: Perform randomisation role is revoked. Please notify user
            this.snackbarColor = "error";
            this.snackbarMessage = `Sorry your access to Airways-3 Randomisation App is revoked. Please contact the Trial Team if you believe your access should stay active. Many thanks.`;
            this.showSnackbar = true;
          }
          this.showBusyAni = false;
        } catch (error) {
          await this.randomiseParticipantOffline();
          this.$router.push({ name: "rand-outcome", params: { notify: true } });
          //this.showBusyAni = false;
          //throw error;
        }
      }
    },
    async randomiseParticipantOffline() {
      //debugger;
      this.deviceOffline = 2;
      this.trialAllocation = Math.floor(Math.random() * 2) + 1;
      this.offlineTempTNO = `${this.appUserId}-${this.randDateTime.format(
        "YYYYMMDD-HHmmss"
      )}`;
      const sdata = {
        randDate: this.randDateTime.format("YYYY-MM-DDTHH:mm:ss"),
        trialAllocation: this.trialAllocation,
        deviceOffline: this.deviceOffline,
        offlineTempTNO: this.offlineTempTNO,
        siteOrgCode: this.siteOrgCode,
        strataTimeOfDay: this.strataTimeOfDay,
        appUserId: this.appUserId,
      };
      //save for frmSyncData
      const db = await openDB("AIRWAYS3idb");
      await db
        .transaction("tbRandomisation", "readwrite")
        .objectStore("tbRandomisation")
        .add(sdata);
      //save for frmRandOutcome
      const mdata = {
        tno: this.offlineTempTNO,
        trialAllocation: this.trialAllocation,
        randDate: this.randDateTime.format("DD/MM/YYYY HH:mm:ss"),
        deviceOffline: this.deviceOffline,
      };
      await db
        .transaction("tbSettings", "readwrite")
        .objectStore("tbSettings")
        .put(mdata, "latestRandResult");

      await db
        .transaction("tbPostRandCRF", "readwrite")
        .objectStore("tbPostRandCRF")
        .add(null, this.offlineTempTNO);

      this.showBusyAni = false;
    },
    async refreshRandForm() {
      this.showRefreshBusyAni = true;
      let clientIsOffline = await this.clientIsOffline();
      if (!clientIsOffline) {
        await this.getSites();
        this.sites = await this.fetchSites();
        this.siteOrgCode = await this.fetchDefaultSiteOrgCode();
      }
      this.strataTimeOfDay = this.getDayOrNight();
      this.randDate = moment().format("YYYY-MM-DD");
      this.randTime = moment().format("HH:mm");
      this.showRefreshBusyAni = false;
    },
    async getSites() {
      const actionUrl = `${process.env.BASE_URL}AppAuth/GetSites`;
      try {
        const {
          data: { rstatus, rdata },
        } = await axios.get(actionUrl, {
          params: { appUserId: this.appUserId },
        });
        if (rstatus == 0) {
          //save data to local idb
          const db = await openDB("AIRWAYS3idb");
          const tx = db.transaction("tbSettings", "readwrite");
          const store = tx.objectStore("tbSettings");
          await store.put(rdata, "sites");
          await store.put(rdata[0].value, "defaultSite");
          await tx.done;
        } else if (rstatus == -2) {
          this.snackbarColor = "error";
          this.snackbarMessage =
            "Sorry, we have noticed an issue with your account setup, please contact the Trial Team.";
          this.showSnackbar = true;
        }
      } catch (error) {
        this.snackbarColor = "error";
        this.snackbarMessage =
          "Sorry, we have noticed an issue with your account setup, please contact the Trial Team.";
        this.showSnackbar = true;
      }
    },
  },
  async mounted() {
    this.setCrfTitle("Randomisation");

    this.strataTimeOfDay = this.getDayOrNight();
    this.randDate = moment().format("YYYY-MM-DD");
    this.randTime = moment().format("HH:mm");

    this.appUserId = await this.fetchAppUserId();
    this.sites = await this.fetchSites();
    this.siteOrgCode = await this.fetchDefaultSiteOrgCode();
  },
};
